
import { SupplierDto, CreateSupplierDto, UpdateSupplierDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { supplierService, SuppliersFilters } from '@services/SupplierService'

const { reducer, actions, thunks } = baseCrudReducer<
  SupplierDto,
  CreateSupplierDto,
  UpdateSupplierDto,
  SuppliersFilters
>('supplier', supplierService)

export default reducer

export const { setFilters: setSupplierFilters } = actions

export const {
  getAll: getSuppliers,
  create: createSupplier,
  update: updateSupplier,
  remove: removeSupplier,
} = thunks
